import _defineProperty from "/app/node_modules/.pnpm/next@12.3.3_@babel+core@7.14.3_react-dom@18.2.0_react@18.2.0_sass@1.49.9/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { useRef, useEffect } from 'react';
import { Button, Cell, Text, Label, DeprecatedIcon } from '@vinted/web-ui';
import { toUrlQuery } from 'libs/utils/url';
import { toggleSearchSubscriptionEvent } from 'libs/common/event-tracker/events';
import { SortByOption } from 'constants/filter';
import { searchDtoToUrlParams } from 'state/saved-searches/transformers';
import useTracking from 'hooks/useTracking';
import useTranslate from 'hooks/useTranslate';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";

const SavedSearchesList = _ref => {
  let {
    searches,
    searchUrl,
    highlightedIndex,
    searchSessionId,
    globalSearchSessionId,
    onSearchClick,
    onSubscribeClick
  } = _ref;
  const translate = useTranslate('saved_searches');
  const {
    track
  } = useTracking();
  const activeSavedSearchRef = useRef(null);
  useEffect(() => {
    var _activeSavedSearchRef;

    (_activeSavedSearchRef = activeSavedSearchRef.current) === null || _activeSavedSearchRef === void 0 ? void 0 : _activeSavedSearchRef.scrollIntoView({
      behavior: 'smooth',
      block: 'nearest'
    });
  }, [highlightedIndex]);

  const onItemClick = search => event => {
    if (onSearchClick) onSearchClick(search, event);
  };

  const onSearchSubscribeClick = search => event => {
    event.stopPropagation();
    event.preventDefault();
    track(toggleSearchSubscriptionEvent({
      searchSessionId,
      isSubscribing: !search.subscribed,
      searchTitle: search.title,
      searchQuery: search.search_text,
      globalSearchSessionId
    }));
    if (onSubscribeClick) onSubscribeClick(search, event);
  };

  function renderSavedSearchSuffix(search) {
    const iconColor = search.subscribed ? DeprecatedIcon.Color.Primary : DeprecatedIcon.Color.GreyscaleLevel1;
    const iconName = search.subscribed ? 'bookmark-filled' : 'bookmark';
    return /*#__PURE__*/_jsx("div", {
      className: "u-position-relative u-zindex-bump",
      children: /*#__PURE__*/_jsx(Button, {
        deprecatedIcon: /*#__PURE__*/_jsx(DeprecatedIcon, {
          name: iconName,
          color: iconColor,
          title: search.subscribed ? translate('a11y.remove_saved_search', {
            title: search.title
          }) : translate('a11y.save_search', {
            title: search.title
          })
        }),
        styling: Button.Styling.Flat,
        theme: "muted",
        testId: "subscription-toggle",
        onClick: onSearchSubscribeClick(search)
      })
    });
  }

  function renderSavedSearchTitle(title, newItemsCount) {
    return /*#__PURE__*/_jsxs("div", {
      className: "u-flexbox",
      children: [!!newItemsCount && /*#__PURE__*/_jsx("div", {
        className: "u-ui-padding-right-small",
        children: /*#__PURE__*/_jsx(Text, {
          text: "+".concat(newItemsCount),
          theme: "primary"
        })
      }), title]
    });
  }

  const renderSavedSearch = _ref2 => {
    let {
      search,
      index
    } = _ref2;
    const {
      id,
      title,
      subtitle,
      new_items_count: newItemsCount
    } = search;

    const params = _objectSpread(_objectSpread({}, searchDtoToUrlParams(search)), {}, {
      search_id: id,
      order: SortByOption.NewestFirst
    });

    const url = "".concat(searchUrl, "?").concat(toUrlQuery(params));
    const isHighlighted = index === highlightedIndex;
    return /*#__PURE__*/_jsx("div", {
      ref: isHighlighted ? activeSavedSearchRef : null,
      children: /*#__PURE__*/_jsx(Cell, {
        type: Cell.Type.Navigating,
        title: renderSavedSearchTitle(title, newItemsCount),
        suffix: renderSavedSearchSuffix(search),
        highlighted: isHighlighted,
        url: url,
        onClick: onItemClick(search),
        aria: {
          'aria-label': search.title
        },
        children: !!subtitle && /*#__PURE__*/_jsx(Text, {
          text: subtitle
        })
      })
    }, id);
  };

  function renderSavedSearches() {
    return /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(Label, {
        text: translate('list.title'),
        type: Label.Type.Stacked
      }), searches.map((search, index) => renderSavedSearch({
        search,
        index
      }))]
    });
  }

  return /*#__PURE__*/_jsx("div", {
    className: "saved-searches",
    children: /*#__PURE__*/_jsx(Cell, {
      styling: Cell.Styling.Tight,
      testId: "saved-searches",
      children: /*#__PURE__*/_jsx("div", {
        className: "saved-searches__content",
        children: renderSavedSearches()
      })
    })
  });
};

export default SavedSearchesList;